import Vue from 'vue';
import Vuesax from 'vuesax';
import InstantSearch from 'vue-instantsearch';
import VeeValidate from 'vee-validate';
import VueCarousel from 'vue-carousel';
import CheckView from 'vue-check-view';
import vSelect from 'vue-select';
import VueSimpleSuggest from 'vue-simple-suggest';
import axios from 'axios';
import 'lazysizes';
// import a plugin
import 'lazysizes/plugins/parent-fit/ls.parent-fit';

import clickOutsideDirective from './directives/click-outside';
import clientClickOutsideDirective from './directives/client-click-outside';
import capitalize from './utilities/capitalize';
import formatDate from './utilities/formatDate';
import Job from './jobs/components/Job.vue';
import { SimpleSVG } from 'vue-simple-svg';
import Bookmarks from './jobs/components/Bookmarks.vue';
import * as VueGoogleMaps from 'vue2-google-maps';
import Events from './mixins/events';
import CCRequestInputMixin from './mixins/CCRequestInputMixin';
import HandleHideWindowsMixin from './mixins/HandleHideWindowMixin';
import SubmissionsMixin from './mixins/SubmissionsMixin';

window.axios = axios;
window.Viewport = require('./Viewport').default;

Vue.use(Vuesax);
Vue.use(InstantSearch);
Vue.use(VeeValidate, {
    fieldsBagName: 'vvFields',
});
Vue.use(VueCarousel);
Vue.use(CheckView);

Vue.component('v-select', vSelect);
Vue.component('simple-svg', SimpleSVG);
Vue.component('vue-simple-suggest', VueSimpleSuggest);
Vue.component(
  'standard-search',
  require('./components/StandardSearch.vue').default,
);
Vue.component(
  'building-icon',
  require('./components/BuildingIcon.vue').default,
);
Vue.component('primary-button', require('./components/Button.vue').default);
Vue.component('secondary-button', require('./components/Button.vue').secondary);
Vue.component('flat-button', require('./components/Button.vue').flat);
Vue.component(
  'advanced-search',
  require('./components/AdvancedSearch.vue').default,
);
Vue.component('v-confetti', require('./components/Confetti.vue').default);
Vue.component('autocomplete', require('./components/Autocomplete.vue').default);
Vue.component('gallery', require('./components/Gallery.vue').default);
Vue.component('pagination', require('./components/Pagination.vue').default);
Vue.component('blog-tab', require('./blogs/Tabs').default);
Vue.component('blog-search', require('./components/BlogSearch').default);
Vue.component(
  'blog-search-results',
  require('./blogs/components/BlogSearchResults').default,
);
Vue.component(
  'blog-header',
  require('./blogs/components/BlogHeader.vue').default,
);
Vue.component(
  'advanced-filter',
  require('./components/AdvancedFilter.vue').default,
);
Vue.component(
  'jobs-cdljn-view-more',
  require('./jobs/components/JobsCdljnViewMore.vue').default,
);

Vue.component('faq-index', require('./faq/Index.vue').default);
Vue.component('faq-featured', require('./faq/FeaturedFaq.vue').default);

if (
  process.env.MIX_USE_MEILISEARCH === 'true' &&
  process.env.MIX_MEILISEARCH_HOST
) {
  Vue.component(
    'jobs-search',
    require('../../vendor/careernowbrands/search/resources/js/components/JobsSearch.vue')
      .default,
  );

  Vue.component(
    'company-search',
    require('../../vendor/careernowbrands/search/resources/js/components/CompanySearch.vue')
      .default,
  );

  Vue.component(
    'home-autocomplete',
    require('../../vendor/careernowbrands/search/resources/js/components/HomeAutocomplete.vue')
      .default,
  );
}

Vue.component(
  'company-jobs-cdljn-view-more',
  require('./jobs/components/CompanyJobsCdljnViewMore.vue').default,
);
Vue.component(
  'trucking-heat-map',
  require('./components/trucking-heat-map/TruckingHeatMap.vue').default,
);
Vue.component('media-tabs', require('./components/MediaTabs.vue').default);
Vue.component(
  'scroll-shadow',
  require('./components/ScrollShadow.vue').default,
);
Vue.use(VueGoogleMaps, {
  load: {
    key: window.GOOGLE_API_KEY,
    libraries: 'places',
  },
});

Vue.component('job-card', require('./jobs/components/JobCard.vue').default);
Vue.component('jobscard', require('./jobs/components/Jobscard.vue').default);
Vue.component('jobsingle', require('./jobs/components/Jobsingle.vue').default);
Vue.component('bookmark', require('./jobs/components/Bookmark.vue').default);
Vue.component('job', require('./jobs/components/Job.vue').default);
Vue.component('applyjob', require('./jobs/components/Applyjob.vue').default);
Vue.component(
  'postjob-form',
  require('./jobs/components/PostJobForm.vue').default,
);
Vue.component(
  'google-map-basic',
  require('./components/vx-gmaps/GoogleMapBasic').default,
);
Vue.component(
  'rounded-corners',
  require('./components/RoundedCorners').default,
);
Vue.component(
  'jobs-view-more',
  require('./jobs/components/JobsViewMore').default,
);
Vue.component('company-result', require('./components/CompanyResult').default);
Vue.component('loader', require('./components/Loader').default);
Vue.component(
  'company-index',
  require('./components/CompanyIndex.vue').default,
);

Vue.directive('click-outside', clickOutsideDirective);
Vue.directive('client-click-outside', clientClickOutsideDirective);

Vue.filter('capitalize', capitalize);
Vue.filter('formatDate', formatDate);

Vue.component('dns-form', require('./dns/components/DnsForm.vue').default);

Vue.component(
  'progress-steps',
  require('./components/ProgressSteps.vue').default,
);

Vue.component(
  'hiring-event-data-time-slot-picker',
  require('./components/HiringEventDateTimeSlotPicker.vue').default,
);

Vue.component(
  'scroll-sticky',
  require('./components/ScrollSticky.vue').default,
);

const mainApp = new Vue({
  el: '#app',

  components: { Job, Bookmarks },

  mixins: [
    Events,
    CCRequestInputMixin,
    HandleHideWindowsMixin,
    SubmissionsMixin,
  ],

  data: function () {
    return {
      showPageLoader: true,
      activeJob: null,
      isJobCards: true,
      sortJobsBy: 'Relevance',
      navOpen: false,
      startPostJobsSvgs: false,
      activeWorks: 'postjobs',
      isDesktop: Viewport.isDesktop,
      isXLDesktop: Viewport.isXLDesktop,
      isDesktopOrGreater: Viewport.isDesktopOrGreater,
      employeesOptions: [
        '1-50 drivers',
        '51 - 200 drivers',
        '201 - 1000 drivers',
        '1001 - 5000 drivers',
        '5001 - 10,000 drivers',
        '10,000+ drivers',
      ],
      companySize: '',

      postJobsIDsSvgs: {
        postjobs: 'eFiwlAzyTtx1',
        getapps: 'eOC5MFQrt3l1',
        fillpos: 'eJxf1j0iC5K1',
      },

      paginationData: {
        data: [],
        tempData: [],
      },

      loadDataPage: 1,
      loadDataLastPage: 1,
      submissionsCounter: 0,
      isMoreResultsBtnVisible: true,

      nextPageNumber: 2,

      blogSearchText: '',
      vsBreadcrumb: null,
      vsBreadcrumbOl: null,
      breadcrumbIsScrolledLeft: false,
      breadcrumbIsScrolledRight: false,
      whichBreadcrumb: '',

      isClientDatePickerDown: true,
      isClientDropDown: true,
      isJobsDropDown: true,
      isChartFilterDropDown: true,
      isSortByDropDown: true,
      isOrderByDropDown: true,
      chartOptionSelect: 'l7d',
      currentClientPaginationPage: 1,
      paginationTotal: 10,
      clientPassword: '',
      clientEmail: '',
      clientSearch: '',
      selectedDate: {},
      selectedDateMobile: {},
      showMobileCalenderCard: true,
      showMobileFilterCard: true,
      showMobileDownloadCard: true,
      sortByOption: '',
      orderByOption: '',
      sortByIndexOption: '',
      orderByIndexOption: '',
      sortByOptions: [
        { value: 'Created Date', label: 'Created Date' },
        { value: 'Job Title', label: 'Job Title' },
        { value: 'Location', label: 'Location' },
        { value: 'Job Status', label: 'Job Status' },
      ],
      orderByOptions: [
        { value: 'ascending', label: 'Ascending' },
        { value: 'descending', label: 'Descending' },
      ],
      setBgOverlay: false,
      clientParsedParams: [],
      activeTab: 'jobs',
      activeClientCompanyId: null,
      viewAtTopOfPage: true,
    };
  },
  created() {
    this.currentClientPaginationPage =
      this.getCurrentPaginationPageFromURLQuery();
    if (window.activeJob) this.selectJob(window.activeJob);

    if (window.innerWidth >= 1024) this.whichBreadcrumb = 'desktop';
    else this.whichBreadcrumb = 'mobile';

    this.setIsMoreResultsBtnVisible();
  },

  beforeMount() {
    window.addEventListener('scroll', this.handleUserScrolls);
  },

  mounted() {
    setTimeout(() => {
      this.showPageLoader = false;
    }, 1000);
    this.sortByIndexOption = this.$refs.sortByInput
      ? this.$refs.sortByInput.value
      : '';
    this.orderByIndexOption = this.$refs.orderByInput
      ? this.$refs.orderByInput.value
      : '';

    if (this.$refs.desktopBreadcrumbs && window.innerWidth >= 1024) {
      this.vsBreadcrumb =
        this.$refs.desktopBreadcrumbs.querySelector('nav.vs-breadcrumb');
      this.vsBreadcrumbOl = this.$refs.desktopBreadcrumbs.querySelector(
        'ol.vs-breadcrumb--ol',
      );
    } else if (this.$refs.mobileBreadcrumbs) {
      this.vsBreadcrumb =
        this.$refs.mobileBreadcrumbs.querySelector('nav.vs-breadcrumb');
      this.vsBreadcrumbOl = this.$refs.mobileBreadcrumbs.querySelector(
        'ol.vs-breadcrumb--ol',
      );
    }

    if (this.vsBreadcrumb && this.vsBreadcrumbOl) {
      this.vsBreadcrumb.addEventListener('scroll', this.breadcrumbScrolled);
      this.breadcrumbScrolled();
    }

    const adjustML = document.querySelector(
      '.client-tabs-line-vs-tabs-adjust-ML .con-ul-tabs ul.ul-tabs.vs-tabs--ul',
    );
    const spanToAppend = document.querySelector(
      '.client-tabs-line-vs-tabs-adjust-ML .con-ul-tabs span.line-vs-tabs',
    );
    if (adjustML && spanToAppend) {
      adjustML.appendChild(spanToAppend);
    }

    /*
         use to listen and set height of element based
         on current screen view height of the device.
         */
    let vh = (window.innerHeight - 32) * 0.01;
    document.documentElement.style.setProperty('--vh', `${vh}px`);
    window.addEventListener('resize', () => {
      vh = (window.innerHeight - 32) * 0.01;
      document.documentElement.style.setProperty('--vh', `${vh}px`);
    });
  },

  computed: {
    getHrefLetsTalk() {
      return url => {
        const prefix = url.includes('?') ? '&' : '?';
        return `${url}${prefix}employees=${this.companySize}`;
      };
    },
    isHowItWorkSelected() {
      return active => {
        return this.activeWorks === active;
      };
    },
    getHowItWorksClass() {
      const classes = {
        bg: {
          active: 'bg-primary-darker',
          inactive: 'bg-chrome-lighter',
        },
        txt: {
          active: 'text-onyx',
          inactive: 'text-chrome',
        },
      };

      return (field, active) => {
        return this.activeWorks === active
          ? classes[field].active
          : classes[field].inactive;
      };
    },
    showBackToJobs() {
      return (
        this.activeJob !== null && (Viewport.isMobile || Viewport.isTablet)
      );
    },

    showOnSelected() {
      return (
        Viewport.isDesktopOrGreater ||
        (this.activeJob === null && (Viewport.isMobile || Viewport.isTablet))
      );
    },

    clientSearchInputPlaceholder() {
      if (window.innerWidth >= 1024) {
        return 'Job title, keywords or location';
      } else {
        return 'Job title, keywords ...';
      }
    },

  },

  methods: {
    scrollToFullForm() {
      if (window.innerWidth < 1024) {
        window.scrollTo(0, 740);
      } else {
        window.scrollTo(0, 160);
      }
    },
    scrollToApplicationForm() {
      document.getElementById('generic-application-form').scrollIntoView({
        behavior: 'smooth',
      });
    },

    handleUserScrolls() {
      // User Scrolling To and Away from Top
      if (window.pageYOffset > 0) {
        if (this.viewAtTopOfPage) this.viewAtTopOfPage = false;
      } else {
        if (!this.viewAtTopOfPage) this.viewAtTopOfPage = true;
      }
    },

    trackGetConnectedBtn(el) {
      if (window.innerWidth < 1024) {
        if (el.type === 'exit' && (el.percentTop < 0 || el.percentCenter < 0)) {
          // show button
          this.$refs.btnGetConnected.classList.remove('hidden');
        } else {
          this.$refs.btnGetConnected.classList.add('hidden');
        }
      }
    },

    trackBottomGetConnectedBtn(el) {
      if (window.innerWidth < 1024) {
        if (el.type === 'enter') {
          this.$refs.btnGetConnected.classList.add('hidden');
        } else if (el.type === 'exit') {
          this.$refs.btnGetConnected.classList.remove('hidden');
        }
      }
    },
    trackFixedGetConnectedBtn(el) {
      if (window.innerWidth < 1024) {
        if (el.type === 'enter') {
          this.$refs.btnGetConnected.classList.add('hidden');
        } else if (el.percentTop >= 1) {
          this.$refs.btnGetConnected.classList.remove('hidden');
        } else if (el.percentTop <= 0) {
          this.$refs.btnGetConnected.classList.remove('hidden');
        }
      }
    },
    /**
     * @param {string} str
     * @param {number} digits
     * @param {string} voidChar
     * @return {string}
     */
    roundedDigits(str, digits = 2, voidChar = '0') {
      return (voidChar + str).slice(digits * -1);
    },
    // searchSubmissions() {
    submitClientSearch() {
      let querySearch = location.search;
      if (querySearch) {
        querySearch += '&kw=' + this.clientSearch;
      } else {
        querySearch = '?kw=' + this.clientSearch;
      }

      const submissionsUrlWithParams = new URL(
        location.origin + location.pathname + querySearch,
      );

      submissionsUrlWithParams.searchParams.delete('page');

      location.href = submissionsUrlWithParams;
    },
    /**
     * @return {int}
     */
    getCurrentPaginationPageFromURLQuery() {
      let querySearch = location.search;

      const jobsUrlWithParams = new URL(
        location.origin + location.pathname + querySearch,
      );

      return parseInt(jobsUrlWithParams.searchParams.get('page')) || 1;
    },
    changeClientPage(pageNumber) {
      let page = this.getCurrentPaginationPageFromURLQuery();

      if (page === pageNumber) return;

      let querySearch = location.search;

      const jobsUrlWithParams = new URL(
        location.origin + location.pathname + querySearch,
      );

      jobsUrlWithParams.searchParams.delete('page');
      jobsUrlWithParams.searchParams.append('page', pageNumber);

      location.href = jobsUrlWithParams;
    },
    breadcrumbScrolled() {
      const navContent = this.vsBreadcrumbOl.getBoundingClientRect();
      const navWrapper = this.vsBreadcrumb.getBoundingClientRect();
      const xFinal = Math.ceil(
        navWrapper.left - (navContent.width - navWrapper.width),
      );
      this.breadcrumbIsScrolledLeft = navContent.x < navWrapper.x;
      this.breadcrumbIsScrolledRight = navContent.x > xFinal;
    },

    /**
     * @param {string} key
     * @param {number} jobID
     */
    setSortJobs(key, jobID) {
      const prevEl = document.getElementById('lc-job' + this.activeJob);
      if (prevEl) prevEl.classList.remove('active');

      this.sortJobsBy = key;
      this.activeJob = jobID;

      this.$nextTick(() => {
        this.selectJob(jobID);
      });
    },
    /**
     * @param {string} href
     */
    listingNotLgJobClicked(href, redirect) {
      if (redirect) window.location = href;
    },

    postJobsSvgPageChange(page) {
      this.$refs[this.activeWorks].classList.remove('restart');

      const svgKey = Object.keys(this.postJobsIDsSvgs)[page];
      this.activeWorks = svgKey;

      this.$refs[svgKey].classList.add('restart');
    },
    activeSVGPostJobs(e) {
      if (e.type === 'exit') return;

      if (
        e.percentCenter < 0.6 &&
        (Viewport.isDesktop || Viewport.isXLDesktop) &&
        this.startPostJobsSvgs === false
      ) {
        this.$refs[this.activeWorks].classList.add('restart');
        this.startPostJobsSvgs = true;
      } else if (
        ((e.percentCenter < 0.45 && Viewport.isTablet) ||
          (e.percentCenter < 0.6 && Viewport.isMobile)) &&
        this.startPostJobsSvgs === false
      ) {
        this.$refs[this.activeWorks].classList.add('restart');
        this.startPostJobsSvgs = true;
      }
    },
    setActiveWorks(active) {
      if (this.activeWorks !== active)
        this.$refs[this.activeWorks].classList.remove('restart');
      this.activeWorks = active;

      Vue.nextTick(() => {
        this.$refs[active].classList.add('restart');
      });
    },
    getPostJobsPerPage() {
      return Viewport.isXLDesktop ? 2 : 1;
    },
    selectJob(jobId) {
      if (Viewport.isMobile || Viewport.isTablet) {
        this.isJobCards = false;

        // do only once
        if (
          !(
            window.history.state &&
            window.history.state['page_id'] &&
            window.history.state['page_id'] === 'back_to_jobs'
          )
        ) {
          window.history.pushState(
            { page_id: 'back_to_jobs' },
            'Back to Jobs',
            window.location.href,
          );

          window.onpopstate = event => {
            this.goBackJobs();
          };
        }
      }

      if (this.activeJob) {
        const prevEl = document.getElementById('lc-job' + this.activeJob);
        prevEl.classList.remove('active');
      }
      this.activeJob = jobId;
      const activeEl = document.getElementById('lc-job' + jobId);
      activeEl.classList.add('active');
      this.$emit('jobSelected');
    },

    goBackJobs() {
      document.body.scrollTop = 0; // For Safari
      document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
      this.activeJob = null;
      if (Viewport.isMobile || Viewport.isTablet) {
        this.isJobCards = true;
      }
    },

    toggleNav() {
      this.navOpen = !this.navOpen;

      if (this.navOpen) {
        document.body.style.overflow = 'hidden';
        document.body.style.position = 'fixed';
        document.body.style.left = '0';
        document.body.style.right = '0';
      } else {
        document.body.style.overflow = '';
        document.body.style.position = 'static';
      }
    },

    toggleBlogNav() {
      let blogSearchNav = this.$refs.blogSearchNav;
      let mainNav = this.$refs.mainNav;

      // use opacity for animation effect on toggle
      if (blogSearchNav.classList.contains('hidden')) {
        blogSearchNav.classList.remove('hidden');
        blogSearchNav.classList.add('opacity-100');
        blogSearchNav.classList.remove('-mt-16');
      } else {
        setTimeout(() => {
          blogSearchNav.classList.remove('opacity-100');
          blogSearchNav.classList.add('hidden');
          blogSearchNav.classList.add('-mt-16');
        }, 300);
      }

      if (mainNav.classList.contains('opacity-100')) {
        mainNav.classList.remove('opacity-100');
        mainNav.classList.add('hidden');
        mainNav.classList.add('-mt-16');
      } else {
        setTimeout(() => {
          mainNav.classList.remove('hidden');
          mainNav.classList.add('opacity-100');
          mainNav.classList.remove('-mt-16');
        }, 300);
      }
    },

    fetchMoreJobs() {
      const prefix = window.location.search.includes('?') ? '&' : '?';
      let url = `${window.location.href}${prefix}page=${this.nextPageNumber}`;

      this.$vs.loading({
        container: '#load-more-button',
        scale: 0.6,
      });

      axios
        .get(url)
        .then(({ data }) => {
          const jobs = Object.keys(data.data).map(key => data.data[key]);
          this.paginationData = {
            ...data,
            data: this.paginationData.data.concat(jobs),
          };

          this.nextPageNumber++;
          this.$vs.loading.close('#load-more-button > .con-vs-loading');
        })
        .catch(err => console.log(err));
    },

    fetchMoreArticles() {
      const prefix = window.location.search.includes('?') ? '&' : '?';
      let url = `${window.location.href}${prefix}page=${this.nextPageNumber}`;

      this.$vs.loading({
        container: '#load-more-button',
        scale: 0.6,
      });

      if (this.paginationData.tempData.length === 0) {
        axios
          .get(url)
          .then(({ data }) => {
            const first12 = data.data.slice(0, 12);
            const next12 = data.data.slice(12);

            this.paginationData = {
              ...data,
              data: this.paginationData.data.concat(first12),
              tempData: next12,
            };
            this.nextPageNumber++;
            this.$vs.loading.close('#load-more-button > .con-vs-loading');
          })
          .catch(err => console.log(err));
      } else {
        // using timeout here to sim async operation for $vs.loading.close() to work
        setTimeout(() => {
          this.paginationData.data = this.paginationData.data.concat(
            this.paginationData.tempData,
          );
          this.paginationData.tempData = [];
          this.$vs.loading.close('#load-more-button > .con-vs-loading');
        }, 300);
      }
    },

    performBlogSearch(urlSearch) {
      if (this.blogSearchText !== '') {
        window.location = this.addCCToRoute(
          `${urlSearch}/${this.blogSearchText}`,
        );
      } else {
        this.toggleBlogNav();
      }
    },

    onBlogSearchQuery(val) {
      this.blogSearchText = val;
    },

    toggleDisplayClientDropdown() {
      this.activateWindow(
        this.$refs.buttonClientProfile,
        this.$refs.clientProfileMenu,
        this.closeClientProfileMenu,
      );
      this.isClientDropDown = !this.isClientDropDown;
    },

    closeClientProfileMenu() {
      this.isClientDropDown = true;
    },

    toggleDisplayJobsDropdown() {
      this.activateWindow(
        this.$refs.buttonClientJobs,
        this.$refs.clientJobsMenu,
        this.closeClientJobsMenu,
      );
      this.isJobsDropDown = !this.isJobsDropDown;
    },

    closeClientJobsMenu() {
      this.isJobsDropDown = true;
    },

    activateClientDatePicker() {
      this.activateWindow(
        this.$refs.buttonClientDatePicker,
        this.$refs.clientDatePicker,
        this.closeClientDatePicker,
      );
      this.isClientDatePickerDown = !this.isClientDatePickerDown;
    },

    closeClientDatePicker() {
      this.isClientDatePickerDown = true;
    },

    toggleChartFilterDropdown() {
      this.isChartFilterDropDown = !this.isChartFilterDropDown;
    },

    closeClientChartMenu() {
      this.isChartFilterDropDown = true;
    },
    extractedUrl() {
      let querySearch = location.search;
      const submissionsUrl = new URL(
        location.origin + location.pathname + querySearch,
      );

      submissionsUrl.searchParams.delete('chd');
      submissionsUrl.searchParams.delete('page'); // remove to reset pagination
      return submissionsUrl;
    },
    chartOptionSelected(val) {
      const submissionsUrl = this.extractedUrl(val);
      const chartKey = val.target.getAttribute('data-key');
      submissionsUrl.searchParams.append('chd', chartKey);

      window.location.href = submissionsUrl;
      this.chartOptionSelect = val.target.innerHTML;
      this.isChartFilterDropDown = true;
    },
    setIsMoreResultsBtnVisible() {
      this.isMoreResultsBtnVisible = this.loadDataPage < this.loadDataLastPage;
    },
    loadedFnOnLoadedData(data) {
      this.setIsMoreResultsBtnVisible();
      this.$vs.loading.close('#dclient-load-more-button > .con-vs-loading');

      // check if url is job/{job_id}/submissions
      if (location.href.includes('submissions')) {
        this.submissionsCounter = data.length;
      }
    },
    fetchMoreDataItems() {
      this.$vs.loading({
        container: '#dclient-load-more-button',
        scale: 0.6,
      });

      this.loadDataPage++;
    },
    displaySaveSubmissionsMenu(job_id) {
      let querySearch = location.search;
      const submissionsUrl = new URL(
        location.origin + location.pathname + querySearch,
      );
      this.queryParams =
        'chd=' +
        (submissionsUrl.searchParams.get('chd')
          ? submissionsUrl.searchParams.get('chd')
          : 'l7d');
      this.activateWindow(
        this.$refs.buttonMore,
        this.$refs.exportableSubmenu.$el,
        this.hideSaveSubmissionsMenu,
      );
      this.exportableJobId = job_id;
      // this.isSubmissionsMenuHidden = false;
      this.$refs.exportableSubmenu.$data.isExportableMenuHidden = false;
    },
    displayExportSubmissionsMenu(job_id) {
      this.activateWindow(
        this.$refs.buttonMoreTwo,
        this.$refs.exportableSubmenuTwo.$el,
        this.hideExportSubmissionsMenu,
      );
      this.exportableJobId = job_id;
      // this.isSubmissionsMenuTwoHidden = false;
      this.$refs.exportableSubmenuTwo.$data.isExportableMenuHidden = false;
    },
    toggleMobileCalenderCard() {
      this.setBgOverlay = !this.setBgOverlay;
      this.showMobileCalenderCard = !this.showMobileCalenderCard;
    },
    toggleMobileFilterCard() {
      this.setBgOverlay = !this.setBgOverlay;
      this.showMobileFilterCard = !this.showMobileFilterCard;
    },
    toggleMobileDownloadCard() {
      this.setBgOverlay = !this.setBgOverlay;
      this.showMobileDownloadCard = !this.showMobileDownloadCard;
    },
    resetMobileCards() {
      this.setBgOverlay = false;
      this.showMobileCalenderCard = true;
      this.showMobileFilterCard = true;
      this.showMobileDownloadCard = true;
    },
    toggleDisplayOrderByDropdown() {
      this.activateWindow(
        this.$refs.buttonOrderBy,
        this.$refs.orderByMenu,
        this.closeOrderByMenu,
      );
      this.isOrderByDropDown = !this.isOrderByDropDown;
    },
    closeOrderByMenu() {
      this.isOrderByDropDown = true;
    },
    toggleDisplaySortByDropdown() {
      this.activateWindow(
        this.$refs.buttonSortBy,
        this.$refs.sortByMenu,
        this.closeSortByMenu,
      );
      this.isSortByDropDown = !this.isSortByDropDown;
    },
    closeSortByMenu() {
      this.isSortByDropDown = true;
    },
    redirectToJob(jobRoute) {
      const tmp = document.createElement('a');
      tmp.href = jobRoute;
      if (tmp.host !== window.location.host || tmp.pathname.startsWith('/r/')) {
        window.open(jobRoute, '_blank');
        window.location.reload();
      } else {
        window.location = jobRoute;
      }
    },
  },
});

export default mainApp;
